export const FileTypeEnum={
    JPG: "JPG",
    PNG: "PNG",
    PDF: "PDF",
    JPEG:"JPEG"
}